import TextField from '@mui/material/TextField';
import AutoComplete from '@mui/material/Autocomplete';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState, useRef } from 'react'; 
import { createTheme, MenuItem, ThemeProvider, Typography } from '@mui/material';

const theme = createTheme({
    components: {
      MuiAutocomplete: {
        styleOverrides: {
          root: {
            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
              fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '500'
            },
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            '&.MuiTypography-root': {
              fontFamily: 'Roboto regular, Helvetica, Arial, sans-serif',
              fontSize: '14px',
              fontWeight: '400'
            },
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            fontFamily: 'Roboto medium, Helvetica, Arial, sans-serif',
            fontSize:'14px',
            fontWeight: '500'
          },
        },
      },
    },
  });


const AutoCompleteInputCopy = ({tag, value, setValue, list, width, font, showError,topAlignTypography=false, disabled=false}) => {
    // initialize ref
    const ref = useRef();
    // set width if not passed as prop
    if (width == null){
        width = '100%';
    }
    // set font size if given as prop, else use default
    let style = {};
    if (font){ 
        style['fontSize'] = font; 
    }
    // event hander to change state variable when a dropdown value is click
    const onInputChange = (e, values) => {
        setValue(value => value = values);
    }

    // event handler to change state variable when textfield changes
    const onTextFieldChange = (e) =>{
        setValue(value => value = e.target.value);
    }

    // event handler to clear state variable when clear is clicked
    const onClear = () => {
        setValue(value => value = '');
    }
    // handle showing error and setting focus
    const [error, setError] = useState(); 
    useEffect(() => {
        if (showError && showError == true) { 
            // set show error
            setError(error => error = true); 
            // focus on error element 
            ref.current.focus();
        }
        else {
            setError(error => error = false); 
        }
    }, [showError]); 

    // render
    return (
        // material ui autocomplete component
        <ThemeProvider theme={theme}>
            <div className={topAlignTypography ? 'd-flex flex-column align-items-start w-100': 'd-flex gap-2 align-items-center w-100'}>
                <Typography>
                    {tag}
                </Typography>
                <FormControl fullWidth size='small' sx={{ width: width }} >
                <AutoComplete
                    id="combo-box-demo"
                    options={ list }
                    size='small'
                    disabled={disabled}
                    value={value}    
                    title={tag}
                    renderInput={(params) => 
                        <TextField 
                            {...params} 
                            style={style} 
                            InputProps={{ ...params.InputProps, style: style }} 
                            InputLabelProps={{style: style}} 
                            onChange={(e)=>onTextFieldChange(e)}
                            error={error}
                            inputRef={ref}
                            placeholder={tag}
                        />
                    }
                    renderOption={(props, option) => 
                        <MenuItem 
                            sx={{whiteSpace:"collapse",borderBottom:"1px solid #E6EDF1"}}
                            {...props} style={style} >{option}
                        </MenuItem>
                    }
                    onChange={(e, values)=>onInputChange(e, values)}
                    onClear={()=>onClear()}
                    disableClearable 
                />
            </FormControl>
            </div>
        </ThemeProvider>
    );
}

export default AutoCompleteInputCopy;
